export default __webpack_public_path__ + "static/media/plus-thin-grey.72b91628.svg";